import { StandardValue } from "common/record/types";

export const isNew = (value: StandardValue) => !value?.record?.properties?.id;

export const isDirty = (value: StandardValue) => !!value?.ui?.detail?.isDirty;
